


const dataFaqs = [
    {
        id: 1,
        title: 'How can I deposit money using Easypaisa?',
        text : "To participate in PUBG Mobile matches, you can deposit money through Easypaisa Open the Easypaisa app and select the 'Send Money' option.Enter the provided account details shared on the website.After sending the payment, upload the Easypaisa transaction receipt in the deposit section of the website.Once verified, your deposit will be reflected in your account balance, usually within a few minutes."  ,
        show: ''
    
    },
    {
        id: 2,
        title: ' Are the matches updated daily?',
        text : "Yes, matches are updated daily on our website. Each day, we add new PUBG Mobile matches with exciting prize pools. You can check the latest matches in the 'Today's Matches' section to stay up-to-date and plan your participation."   ,     show: ''
    
    },
    {
        id: 3,
        title: " Why can I only see today's matches?",
        text : "Our platform focuses on delivering real-time tournaments. To avoid confusion with past or future matches, we display only today's matches. This ensures that players can easily find and join ongoing or upcoming games scheduled for the current day.",        show: ''
    
    },
    {
        id: 4,
        title: 'Is my sensitive information safe when signing up?',
        text :"Yes, we take your privacy seriously. All personal information provided during signup, such as your mobile number and payment details, is encrypted and securely stored. We follow strict data protection protocols to ensure your information remains confidential and is not shared with third parties." ,       show: ''
    
    },
    {
        id: 5,
        title: 'What happens if I exit after getting the room ID and password?',
        text : "If you exit the participation from the match after receiving the room ID and password,All the players data is checked inside the room of PUBG mobile.if we find any user that is not in the match details database then he will be kicked out and further inspection will follow ,even blocking his account on this platform, ensuring high integrety,competition fair play gaming. ",      show: ''
    
    },
    {
        id: 6,
        title: 'How can I withdraw my winnings using Easypaisa?',
        text : "Withdrawing your prize money through Easypaisa is simple: Go to the 'Withdraw' section on the website and enter the amount you'd like to withdraw. Provide your Easypaisa account details. Submit the request, and the amount will be transferred to your Easypaisa account within the specified processing time."   ,   show: ''
    
    },


   

   
]

export default dataFaqs;